import { render } from "./CoursesPageThree.vue?vue&type=template&id=71bb9507"
import script from "./CoursesPageThree.vue?vue&type=script&lang=js"
export * from "./CoursesPageThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__